import * as types from '@/store/mutation-types'
import apolloClient from '@/api/apollo'

import FETCH_VEHICLES from '@/graphql/queries/Guests/FetchVehicles.graphql'
import FETCH_GUESTS from '@/graphql/queries/Guests/FetchGuests.graphql'
import CREATE_GUEST from '@/graphql/mutations/Guests/CreateGuest.graphql'
import REMOVE_GUEST from '@/graphql/mutations/Guests/RemoveGuest.graphql'
import UPDATE_GUEST from '@/graphql/mutations/Guests/UpdateGuest.graphql'
import FETCH_PERMISSIONS from '@/graphql/queries/Guests/FetchPermissions.graphql'

const namespaced = true

const state = {
  vehicles: [],
  guests: [],
  permissions: []
}

const getters = {
  guests: state => {
    return state.guests.map(guest => {
      const vehicles = guest.vehicles.map(vehicle => {
        return vehicle._id
      })
      return {
        ...guest,
        vehicles
      }
    })
  }
}

const mutations = {
  [types.SET_VEHICLES] (state, { vehicles }) {
    state.vehicles = vehicles
  },
  [types.SET_GUESTS] (state, { guests }) {
    state.guests = guests
  },
  [types.CREATE_GUEST] (state, { guest }) {
    state.guests = [ ...state.guests, guest ]
  },
  [types.SET_PERMISSIONS] (state, { permissions }) {
    state.permissions = permissions
  }
}

const actions = {
  async fetchGuests ({ commit }) {
    const result = await apolloClient.query({
      query: FETCH_GUESTS
    })
    const guests = result.data.fetchGuests
    commit(types.SET_GUESTS, { guests })
  },
  async fetchVehicles ({ commit }) {
    const result = await apolloClient.query({
      query: FETCH_VEHICLES
    })
    const vehicles = result.data.fetchVehicles
    commit(types.SET_VEHICLES, { vehicles })
  },
  async fetchPermissions ({ commit }) {
    const result = await apolloClient.query({
      query: FETCH_PERMISSIONS
    })
    const permissions = result.data.fetchPermissions
    commit(types.SET_PERMISSIONS, { permissions })
  },
  async createGuest ({ commit }, { guest }) {
    const result = await apolloClient.mutate({
      mutation: CREATE_GUEST,
      variables: {
        guest
      }
    })
    const createdGuest = result.data.createGuest
    commit(types.CREATE_GUEST, { guest: createdGuest })
  },
  async removeGuest ({ commit }, { _id }) {
    const result = await apolloClient.mutate({
      mutation: REMOVE_GUEST,
      variables: {
        _id
      }
    })
    const guests = result.data.removeGuest
    commit(types.SET_GUESTS, { guests })
  },
  async updateGuest ({ commit }, { _id, guest }) {
    const result = await apolloClient.mutate({
      mutation: UPDATE_GUEST,
      variables: {
        _id,
        guest
      }
    })
    const guests = result.data.updateGuest
    commit(types.SET_GUESTS, { guests })
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/guests/index.js